import { render, staticRenderFns } from "./bgHome.vue?vue&type=template&id=48cf0404&scoped=true&"
import script from "./bgHome.vue?vue&type=script&lang=js&"
export * from "./bgHome.vue?vue&type=script&lang=js&"
import style0 from "./bgHome.vue?vue&type=style&index=0&id=48cf0404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf0404",
  null
  
)

export default component.exports